export const STORAGE_KEYS = {
  LOGGED_IN_USER_EMAIL: "logged-in-user-email",
  IS_FIRST_LOGIN: "is-first-login",
  ADMIN_MESSAGE_ID: "admin-message-id",
  DISMISSED_MESSAGE_ID: "dismissed-message-id",
  LOCATION: "location",
  HYBRID_PREVIEW: "hybrid-preview",
};
